import { aftershootLogo, aftershootTitle } from "@/assets/shared";
import { CheckCircleIcon } from "@pkg/icons";
import { useLocation } from "@/lib/router";
import { POSTHOG_EVENT } from "@/services/posthog/data";
import eventTrackingHandler from "@/tracking/eventTrackingHandler";
import { cn } from "@/utils/cn";
import { detectPlatform } from "@/utils/platformDetection";
import { useAuth } from "reactfire";
import { userTryReDownload } from "../../../services/posthog";
import { PRO_DATA } from "../data/ob-constant";

type TProps = {
  handleDownload: () => void;
};

const DownloadStatusCard = (props: TProps) => {
  const { handleDownload } = props;

  const auth = useAuth();
  const location = useLocation();

  const userEmail = auth.currentUser?.email;

  const handleTryAgain = () => {
    const { platform, fileType } = detectPlatform();

    // Track the manual re-download event
    eventTrackingHandler(POSTHOG_EVENT.DOWNLOAD_AFTERSHOOT_CTA_CLICKED, {
      types: ["posthog", "customerio"],
      properties: {
        device_type: platform,
        platform: platform,
        file_type: fileType,
        origin: location.pathname,
        source: "download_status_card",
        download_method: "manual",
        is_retry: true,
      },
    });

    handleDownload();
    userTryReDownload(userEmail ?? "email-na");
  };

  return (
    <div className="relative mx-auto my-auto flex w-full flex-col items-center justify-center gap-10 overflow-hidden px-6 py-10 text-black lg:top-1/2">
      <div className="flex items-center gap-2">
        <img src={aftershootLogo} alt="Logo Icon" className="h-7" />
        <img src={aftershootTitle} alt="Logo" className="h-[15px]" />
      </div>

      <div className="flex flex-col items-center gap-2 text-center">
        <h2 className="text-center font-erode-variable text-[40px] leading-[110%] font-light tracking-[-1.2px] not-italic">
          Download Has Started!
        </h2>
        <p className="text-center font-archivo text-base leading-[110%] font-normal tracking-[-0.48px] not-italic">
          Aftershoot is now being downloaded to your device.
        </p>
      </div>

      <div className="rounded-lg border border-black/5 bg-[rgba(226,226,226,0.3)] px-6 py-4 backdrop:blur-2xl">
        <h2 className="mb-2 text-center text-2xl leading-[140%] font-normal tracking-[-0.72px] not-italic">
          Congratulations!
        </h2>
        <p className="text-center text-base leading-[150%] font-normal tracking-[-0.48px] not-italic">
          Your <strong> 30-day free trial</strong> of Aftershoot Complete has
          started
        </p>

        <div className="my-4 h-[0.5px] w-full bg-edge-3" />

        <div className="text-sm font-light">
          <div className="mb-4">What's included in your trial:</div>

          <div className="flex w-full grid-cols-2 flex-col justify-between gap-x-2 gap-y-4 sm:grid">
            {PRO_DATA.map((item: string, index) => {
              return (
                <div
                  key={index}
                  className={cn(
                    "flex w-max items-center gap-2 text-sm font-light",
                  )}
                >
                  <CheckCircleIcon className="text-tag-green-primary" />
                  <span dangerouslySetInnerHTML={{ __html: item }}></span>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div className="mt-[-16px] text-center font-archivo text-base leading-[110%] font-normal tracking-[-0.48px] not-italic">
        <h2>Download failed?</h2>
        <button
          onClick={handleTryAgain}
          className="mx-auto mt-2 cursor-pointer text-center font-bold text-[#6599FF]"
        >
          Try again
        </button>
      </div>

      {/* <div
        className="absolute left-[-60%] top-[-55%] h-[552px] w-[552px] rotate-[-105.646deg] rounded-[552px] blur-[60px]"
        style={{
          background: `linear-gradient(
          127deg,
          rgba(126, 104, 176, 0.5) 34.45%,
          rgba(239, 64, 35, 0.5) 99.3%
        )`,
        }}
      />
      <div
        className="absolute bottom-[-55%] right-[-75%] h-[552px] w-[552px] rotate-[-105.646deg] rounded-[552px] blur-[60px]"
        style={{
          background: `linear-gradient(
        127deg,
        rgba(126, 104, 176, 0.5) 34.45%,
        rgba(239, 64, 35, 0.5) 99.3%
      )`,
        }}
      /> */}
    </div>
  );
};

export default DownloadStatusCard;
